import React, { PureComponent } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MainTemplate from './MainTemplate';
import { precacheImages } from '../../redux/Precache/actions';

import tabs from '../../content/navigation.json';

const AUTO_PLAY_INTERVAL = 20000;

class Main extends PureComponent {
  constructor(...props) {
    super(...props);

    this.state = {
      currentIndex: this.getCurrentIndex(),
      nextIndex: this.getCurrentIndex(),
      forceIndex: null
    };
  }

  componentWillMount() {
    if (typeof window === 'undefined') {
      return;
    }

    const images = tabs.map(tab => tab.background);
    images.push('/main/overlay.jpg');

    if (this.props.layout === 'desktop') {
      for (const tab of tabs) {
        images.push(...tab.parallax);
      }
    }

    this.props.precacheImages(images);
  }

  componentDidMount() {
    document.body.addEventListener('keypress', this.setAutoSlideInterval);
    document.body.addEventListener('click', this.setAutoSlideInterval);
    this.setAutoSlideInterval();
  }

  componentWillUnmount() {
    document.body.removeEventListener('keypress', this.setAutoSlideInterval);
    document.body.removeEventListener('click', this.setAutoSlideInterval);
    this.clearAutoSlideInterval();
  }

  clearAutoSlideInterval = () => {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  };

  setAutoSlideInterval = (event) => {
    if (event && !this.interval) {
      return;
    }

    this.clearAutoSlideInterval();

    this.interval = setInterval(() => {
      const { currentIndex } = this.state;
      const index = (currentIndex + 1) % tabs.length;
      browserHistory.push(tabs[index].pathname);
    }, AUTO_PLAY_INTERVAL);
  };

  componentWillReceiveProps(nextProps) {
    const { pathname } = this.props.location;

    if (pathname !== nextProps.location.pathname) {
      const forceIndex = tabs.findIndex(tab =>
        tab.pathname === nextProps.location.pathname);

      this.setState({ forceIndex });
    }

    if (nextProps.panel !== this.props.panel) {
      if (!!nextProps.panel) {
        this.clearAutoSlideInterval();
      } else {
        this.setAutoSlideInterval();
      }
    }
  }

  getCurrentIndex() {
    const { pathname } = this.props.location;
    return tabs.findIndex(tab => pathname.startsWith(tab.pathname));
  }

  onSlide = (currentIndex, nextIndex) => {
    const { pathname } = tabs[currentIndex];

    if (currentIndex === nextIndex) {
      browserHistory.push(pathname);
      this.setState({ currentIndex, nextIndex, forceIndex: null });
    } else {
      this.setState({ currentIndex, nextIndex });
    }
  };

  onNextClick = () => {
    const { currentIndex } = this.state;
    const index = (currentIndex + 1) % tabs.length;
    browserHistory.push(tabs[index].pathname);
  };

  onPrevClick = () => {
    let index = this.state.currentIndex - 1;

    if (index < 0) {
      index = tabs.length - 1;
    }

    browserHistory.push(tabs[index].pathname);
  };

  render() {
    const {
      currentIndex,
      nextIndex,
      forceIndex
    } = this.state;

    return (
      <MainTemplate
        activeIndex={currentIndex}
        nextIndex={nextIndex}
        forceIndex={forceIndex}
        tabs={tabs}
        isMobile={this.props.layout !== 'desktop'}
        onSlide={this.onSlide}
        onNextClick={this.onNextClick}
        onPrevClick={this.onPrevClick}
      />
    );
  }
}

Main.propTypes = {
  layout: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),
  panel: PropTypes.string,
  precacheImages: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  layout: state.app.layout,
  panel: state.app.panel
});

const mapDispatchToProps = {
  precacheImages
};

const MainPage = connect(mapStateToProps, mapDispatchToProps)(Main);

const createRoute = (pathname) => ({
  path: `/${pathname}/`,
  component: MainPage
});

const main = [
  'we',
  'manage',
  'analyze',
  'promotion',
  'support',
  'success-stories'
];

export default main.map(createRoute);



// WEBPACK FOOTER //
// ./src/components/Main/index.js